module.exports = __webpack_public_path__ + "assets/img/0802.8cacf613.svg";